const normalizeText = (value) => String(value ?? "").trim();

const parsePositiveNumber = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.trunc(parsed));
};

export const parseOpenActivityCount = (value) => parsePositiveNumber(value);

export const hasOpenScheduledActivities = (record = {}) => {
  if (!record || typeof record !== "object") return false;
  if (parseOpenActivityCount(record.open_activity_count ?? record.openActivityCount) > 0) return true;
  return Boolean(
    record.next_activity_id ||
      record.nextActivityId ||
      record.next_activity_due_at ||
      record.nextActivityDueAt ||
      record.next_activity_type ||
      record.nextActivityType
  );
};

export const isTerminalLeadStageOption = (stage = {}) => {
  const stageType = normalizeText(stage?.stage_type ?? stage?.stageType).toLowerCase();
  if (stageType === "closed") return true;
  const stageKey = normalizeText(stage?.stage_key ?? stage?.stageKey ?? stage?.value).toLowerCase();
  if (stageKey === "failed" || stageKey === "faild") return true;
  const label = normalizeText(stage?.label ?? stage?.name ?? stage?.title).toLowerCase();
  return label === "failed" || label === "faild";
};

export const isLostDealStageOption = (stage = {}) => {
  const stageType = normalizeText(stage?.stage_type ?? stage?.stageType ?? stage?.status).toLowerCase();
  if (stageType === "lost") return true;
  const stageKey = normalizeText(stage?.stage_key ?? stage?.stageKey ?? stage?.value).toLowerCase();
  if (stageKey === "lost") return true;
  const label = normalizeText(stage?.label ?? stage?.name ?? stage?.title).toLowerCase();
  return label === "lost";
};

export const shouldConfirmLeadTerminalTaskClosure = ({ stage, record } = {}) => {
  return isTerminalLeadStageOption(stage) && hasOpenScheduledActivities(record);
};

export const shouldConfirmDealLostTaskClosure = ({ stage, record } = {}) => {
  return isLostDealStageOption(stage) && hasOpenScheduledActivities(record);
};

export const buildTaskClosureConfirmMessage = ({
  translate,
  entityLabel = "",
  openActivityCount = 0,
} = {}) => {
  const key = "ncrm.activities.closeOpenTasks.confirm";
  const count = parseOpenActivityCount(openActivityCount);
  const entity = normalizeText(entityLabel);
  if (typeof translate === "function") {
    const message = translate(key, { count, entity });
    if (message && message !== key) return message;
  }

  const subject = entity || "this record";
  const countText = count > 0 ? `${count} active task${count === 1 ? "" : "s"}` : "active tasks";
  return `There are ${countText} for ${subject}. If you continue, active tasks will be closed automatically. Continue?`;
};

export const confirmTaskClosure = ({
  translate,
  entityLabel = "",
  record = {},
  confirmFn = globalThis?.confirm,
} = {}) => {
  if (typeof confirmFn !== "function") return false;
  return confirmFn(
    buildTaskClosureConfirmMessage({
      translate,
      entityLabel,
      openActivityCount: record?.open_activity_count ?? record?.openActivityCount,
    })
  );
};

export const resolveLeadTerminalTaskClosureConfirmation = (options = {}) => {
  if (!shouldConfirmLeadTerminalTaskClosure(options)) return false;
  return confirmTaskClosure(options) ? true : null;
};

export const resolveDealLostTaskClosureConfirmation = (options = {}) => {
  if (!shouldConfirmDealLostTaskClosure(options)) return false;
  return confirmTaskClosure(options) ? true : null;
};
